import { store } from "../store.js";
import { parsers } from "./parsers.js";

class ServeParser {
  constructor() {
    parsers.addType("serve", this._applyServe.bind(this));
  }

  _applyServe(serveData) {
    store.set("serve", serveData, true);
  }
}

const serveParser = new ServeParser();
export { ServeParser, serveParser };
